module.exports = __webpack_public_path__ + "2336916f486808ae78ee7e28b497e586.jpg";